// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qe3WR","col":"styles_col__2inrX"};